import { CreatorForm } from '@features/creator/CreatorForm'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'

export default function CreatorPage() {
  return (
    <Box sx={{ height: '100%', display: 'grid', justifyContent: { xs: 'center', md: 'end' }, alignItems: 'center' }}>
      <Box
        sx={(theme) => ({
          color: theme.palette.text.primary,
          display: 'grid',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: { xs: '100%', md: '100%' },
          position: 'relative',
          right: { xs: undefined, md: '40%' },
          p: 2,
        })}
      >
        <Paper
          sx={{ p: 4 }}
          elevation={1}
        >
          <CreatorForm />
        </Paper>
      </Box>
    </Box>
  )
}
